import type { ReleaseNote } from "../release-types";

/**
 * Utrulling av de små forbedringene som har stått bak funksjonsbrytere for
 * superadmin siden august til oktober (timeføring, budsjett, prosjekter,
 * feedback). Utkast skrevet av agent, Erik eier teksten.
 */
export const TIMER_OG_PROSJEKTER_2026_10: ReleaseNote = {
  id: "2026-10-27-timer-og-prosjekter",
  date: "2026-10-27",
  module: "Timer og prosjekter",
  title: "Små forbedringer i timeføring og på prosjektene",
  intro:
    "Jeg har slått på en rekke forbedringer som har vært testet en stund. De fleste sparer deg for et par klikk når du fører timer eller ser på et prosjekt.",
  themes: [
    {
      heading: "Timeføring",
      items: [
        {
          title: "Helg- og helligdagstimer foreslås automatisk",
          body: "Fører du timer på en lørdag, søndag eller helligdag, er timene forhåndsutfylt som helg/helligdag. Du kan alltid endre før du lagrer.",
        },
        {
          title: "Oppgaver på internprosjekter",
          body: "Du kan opprette oppgaver på internprosjekter og føre timer mot oppgaven, ikke bare mot prosjektet. Timene grupperes per oppgave.",
        },
        {
          title: "Varsel om hull før du avslutter måneden",
          body: "Rett over Avslutt-knappen står det hvor mange ukedager som mangler timer, og hvor mange som er underført. Det er bare et varsel, du kan fortsatt avslutte.",
        },
      ],
    },
    {
      heading: "Budsjettet på prosjektet",
      items: [
        {
          title: "Se når kollegene har ført timer",
          body: "Hold musen over (eller trykk på) en persons «Brukt»-tall, så ser du føringene bak: dato, fra–til og varighet.",
        },
      ],
    },
    {
      heading: "Prosjekter",
      items: [
        {
          title: "Lagring på avsluttede prosjekter",
          body: "Velger du «Avsluttet» på Prosjekter, får du en kolonne med datamengde og lagringssted, med sum nederst.",
        },
      ],
    },
    {
      heading: "Feedback",
      items: [
        {
          title: "Si hvor hardt saken rammer deg",
          body: "Feedback-skjemaet spør hvor alvorlig saken er. Det avgjør hva som skjer videre:",
          bullets: [
            "Blokkerer meg: fikses samme dag",
            "Feil, men jeg kommer videre: vurderes av William",
            "Kosmetisk: vurderes i månedlig gjennomgang",
          ],
        },
      ],
    },
  ],
};
